var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { styled, css } from '@creditas-ui/react';
export var StyledTable = styled.table(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  border-collapse: collapse;\n  width: ", ";\n"], ["\n  border-collapse: collapse;\n  width: ", ";\n"])), function (_a) {
    var fullWidth = _a.fullWidth;
    return (fullWidth ? '100%' : 'auto');
});
export var TableCell = styled.td(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  font-size: ", ";\n  padding: ", ";\n  text-align: ", ";\n  line-height: ", ";\n  letter-spacing: ", "px;\n"], ["\n  font-size: ", ";\n  padding: ", ";\n  text-align: ", ";\n  line-height: ", ";\n  letter-spacing: ", "px;\n"])), function (_a) {
    var theme = _a.theme;
    return theme.fontSizes.md;
}, function (_a) {
    var theme = _a.theme;
    return "".concat(theme.spacingX['xl'], " ").concat(theme.spacingX['5xl']);
}, function (_a) {
    var textAlign = _a.textAlign;
    return (textAlign ? textAlign : 'left');
}, function (_a) {
    var theme = _a.theme;
    return theme.lineHeight.md;
}, function (_a) {
    var theme = _a.theme;
    return theme.letterSpacing.xs;
});
export var THeadCell = styled(TableCell)(templateObject_3 || (templateObject_3 = __makeTemplateObject([""], [""])));
THeadCell.defaultProps = {
    as: 'th',
};
export var TableBody = styled.tbody(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (_a) {
    var striped = _a.striped, _b = _a.stripedColorOdd, stripedColorOdd = _b === void 0 ? 'transparent' : _b, stripedColorEven = _a.stripedColorEven, theme = _a.theme;
    return striped && css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n      tr:nth-of-type(even) td {\n        background-color: ", ";\n      }\n      tr:nth-of-type(odd) td {\n        background-color: ", ";\n      }\n    "], ["\n      tr:nth-of-type(even) td {\n        background-color: ", ";\n      }\n      tr:nth-of-type(odd) td {\n        background-color: ", ";\n      }\n    "])), stripedColorEven !== null && stripedColorEven !== void 0 ? stripedColorEven : theme.colors.neutral[10], stripedColorOdd);
});
export var TableRow = styled.tr(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  border-bottom: 1px solid ", ";\n\n  td {\n    color: ", ";\n  }\n\n  &:hover td {\n    background-color: ", ";\n    opacity: ", ";\n  }\n"], ["\n  border-bottom: 1px solid ", ";\n\n  td {\n    color: ", ";\n  }\n\n  &:hover td {\n    background-color: ", ";\n    opacity: ", ";\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.neutral['20'];
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.neutral['100'];
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.neutral['10'];
}, function (_a) {
    var theme = _a.theme;
    return theme.opacity.xl;
});
export var TableHead = styled.thead(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n  th,\n  td {\n    padding: ", ";\n    font-weight: ", ";\n    font-size: ", ";\n    color: ", ";\n    background-color: ", ";\n  }\n\n  tr {\n    border-top: 1px solid ", ";\n    border-bottom: initial;\n    line-height: 0.5;\n  }\n"], ["\n  th,\n  td {\n    padding: ", ";\n    font-weight: ", ";\n    font-size: ", ";\n    color: ", ";\n    background-color: ", ";\n  }\n\n  tr {\n    border-top: 1px solid ", ";\n    border-bottom: initial;\n    line-height: 0.5;\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return "".concat(theme.spacingTop.xl, " ").concat(theme.spacingRight['5xl'], " ").concat(theme.spacingBottom['4xl']);
}, function (_a) {
    var theme = _a.theme;
    return theme.fontWeight.lg;
}, function (_a) {
    var theme = _a.theme;
    return theme.fontSizes.sm;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.neutral['100'];
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.neutral['10'];
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.neutral['10'];
});
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7;
//# sourceMappingURL=Table.style.js.map